import { isMockServices } from 'src/utils';
import mock from 'src/services/utils/mock';
import { getCompatibleAuthTokenHttp } from '../utils/enhancedAuthTokenHttp';
import { MutationFunction } from '@tanstack/react-query';

export interface UpdateUserParams {
  userId: string;
  firstName?: string | null;
  lastName?: string | null;
  externalEncompassId?: string | null;
}

const updateUser: MutationFunction<boolean, UpdateUserParams> = async (
  args,
) => {
  if (isMockServices()) {
    return await mock(_mockData);
  }

  const formData = new FormData();

  if (args.firstName !== undefined && args.firstName !== null) {
    formData.append('firstName', args.firstName);
  }
  if (args.lastName !== undefined && args.lastName !== null) {
    formData.append('lastName', args.lastName);
  }
  if (args.externalEncompassId !== undefined) {
    formData.append('externalEncompassId', args.externalEncompassId ?? '');
  }

  const authTokenHttp = await getCompatibleAuthTokenHttp();
  const response = await authTokenHttp<{ success: boolean }>(
    `/shared/users/${args.userId}`,
    {
      method: 'PUT',
      body: formData,
      // Don't set Content-Type header - let browser set it for FormData
    },
  );

  if (response.data) return response.data.success;
  throw new Error('Failed to update user');
};

export default updateUser;

const _mockData: boolean = true;
